// extracted by mini-css-extract-plugin
export var footer = "dh_nc";
export var footer_copy = "dh_pc";